import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Icon } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { TeamShipHealth } from './sharpshooter-types';

interface Props {
    teamShipStatus: TeamShipHealth[];
}

export const TeamScoreboard = (props: Props) => (
    <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="team scoreboard table">
            <TableHead>
                <TableRow>
                    <TableCell align="center">Team Name</TableCell>
                    <TableCell align="center">Total Ships</TableCell>
                    <TableCell align="center">Sunk Ships</TableCell>
                    <TableCell align="center">Still playing</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.teamShipStatus.map((row) => (
                    <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell component="th" scope="row">
                            {row.name}
                        </TableCell>
                        <TableCell align="center">{row.ships}</TableCell>
                        <TableCell align="center">{row.destroyed}</TableCell>
                        <TableCell align="center">
                            {row.ships === row.destroyed ? (
                                <Icon color="error">
                                    <CancelIcon />
                                </Icon>
                            ) : (
                                <Icon color="success">
                                    <CheckCircleIcon />
                                </Icon>
                            )}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
);
